import { useState, useEffect } from 'react';
import { getStories, supportStory } from '../services/firestore';

export function useStories() {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);
  const [lastDoc, setLastDoc] = useState(null);
  const [hasMore, setHasMore] = useState(true);

  const fetchStories = async (reset = false) => {
    try {
      if (reset) {
        setLoading(true);
        setLastDoc(null);
      }
      const { items: data, lastDoc: newLastDoc, hasMore: more } = await getStories(20, reset ? null : null);
      setStories(data);
      setLastDoc(newLastDoc);
      setHasMore(more);
      setError(null);
    } catch (err) {
      console.error('Error fetching stories:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const loadMore = async () => {
    if (!hasMore || loadingMore) return;

    try {
      setLoadingMore(true);
      const { items: data, lastDoc: newLastDoc, hasMore: more } = await getStories(20, lastDoc);
      setStories(prev => [...prev, ...data]);
      setLastDoc(newLastDoc);
      setHasMore(more);
    } catch (err) {
      console.error('Error loading more stories:', err);
    } finally {
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    fetchStories(true);
  }, []);

  const support = async (storyId, userId) => {
    try {
      await supportStory(storyId, userId);
      await fetchStories(true); // Refresh the list
    } catch (err) {
      console.error('Error supporting story:', err);
      throw err;
    }
  };

  return { stories, loading, loadingMore, error, refetch: () => fetchStories(true), support, loadMore, hasMore };
}
